import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpParameterCodec } from "@angular/common/http";
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { ModalInfoComponent } from 'projects/hp-api/src/lib/base/modal-info.component';
import { Product, UserAuthenticate } from '../models/model';
import { v4 as uuidv4 } from 'uuid';
import { HpServiceConfig } from './hp.service.config';
import { Frame } from 'scenejs';
import { RouterModule, Routes, Router, ActivatedRoute, Params } from '@angular/router';
import { NullAstVisitor } from '@angular/compiler';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { debug } from 'console';

@Injectable({
  providedIn: 'root'
})
export class HpService {

  private config: HpServiceConfig;
  private configLoaded = false;

  private headers = new HttpHeaders(
    {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      Accept: '*/*'

    }
  );

  public currentUserAuthenticateSubject!: BehaviorSubject<UserAuthenticate>;
  public currentUserAuthenticate!: Observable<UserAuthenticate>;
  public userAuthenticate !: UserAuthenticate;
  private currentProductSubject: BehaviorSubject<Product>;
  public currentProduct!: Observable<Product>;
  public dataChangeSubject: BehaviorSubject<string>;
  public dataChange!: Observable<string>;
  public product !: Product;
  public globalData: any;
  public rootProduct: any;
  public familles: any;
  public params: any;
  public url_api: any;
  public api_username: any;
  public api_pwd: any;
  public catId: any;
  public multiProductCatId: any;
  public socNom: any;
  public prodId: any;
  public answer: any;
  public hp_catalogue: any;
  public reqUrl: any;
  public hp_paramaters = "";
  private assetsPath: any;
  private url_ambiance: any;
  private pdfModelGuid: string;
  questionKewords: any;
  curentQuestion: any =[]; 
  optionSelected: any;

  ///Api hp
  public hpCatalogue: any;
  public sousFamille: any;
  public listProducts: any =[];
  public responses: any;
  public dimesions: any;
  public token: any;
  public multiProductTokens: any = [];
  public hasDimension = false;
  public multiGlobalData: any = [];
  public startProduct: any;
  public startMultiProduct: any = [];
  public startDirectProductConfig: any =[];
  public view = "0";
  //public viewAnswer: any;
  matButtonDisabled = true;
  private stockableAnswers: any =[];

  private route_path;
  public questionsById: any;
  public questionsByIdCode: any;
  private base64String = "";
  private vue = "0";
  private isHeaderIn = true;
  private currentPage = 0;
  private previousPage = 0;
  private router: Router;
  etape_finale = false;
  isUploadExt = false;
  isUploadInt = false;
  namePhoto_ext: any;
  namePhoto_int: any;

  //questionsViewStockableForInsideView: any;
  //questionsViewStockableForOutsideView: any;

  is_loading = false;

  private type_visual = "view-0";
  private type_visual_int = "view";
  private visual_type = "view";
  private targetIntCss: any;

  private projectGuid: string = null;
  private productGuid: string = null;
  private xParams: string = null;
  modalInfoOpened = true;
  filterKeyword= "";

  private callback_url_external_tool: string;

  framesExt: Frame;
  framesInt: Frame;

  transformCss = [];

  inReverseExt = false;
  inReverseInt = false;

  imageCanvasExt: any;
  imageCanvasInt: any;
  private thumbnails: any;
  private catalog_filters_def: any;
  private lastData: any;
  private targetCss: any;
  private user_is_pro = false;
  private limit_: number;
  private href_iframe: any;
  private warpable = true;
  private breakPointWidthPhone = 480;
  private breakPointHeightPhone = 480;
  private breakPointWidthTablet = 1180;
  private breakPointHeightTablet = 640;
  private breakPointWidthDkptMini = 1370;


  idCouleurExt;
  idCouleurInt;
  panneaux = [];
  initProductId: any;
  private dataMap: any;
  default_couleur: any =[];
  couleur_d: any
  defaultProduct: any;
  app_loader = false;
  modeles = [];
  isMobile = false;
  isTablet = false;
  isDesktop = true;
  isLandscape = true;
  isPortrait = false;
  isDkptMinWidth = false;
  menuAnswerState = "in";
  multiMenuAnswerState ="in";
  dataobj: any;
  areaPorteIndex: any;
  public currentFormeId = 1;
  private observer: BreakpointObserver
  /**
   * 
   * @param MultiProduct 
   */
globalDataProduct:any;
 globalDataLoaded:any;
 productsFrames:any =[]; 
 default_couleurs: any = [];
 hiddenQuestions: any = [];
 subQuestions: any = [];
 topQuestions: any = [];
 ovConfigCat:any = [];
 questionsViewStockable:any = [];
 tpSubQuestions : any =[];
 cloneControle: any =[{"parentIndex": 0, "idModele": "U0SR2E", "isClone": false}];
 currentViewQuestion: any =[];
 currentElement_type: any =[];
  currentVitrage_type: any =[];
  currentType_ouverture : any =[];
  currentGamme: any = [];
  currentMatiere: any = [];
  currentForme: any = [];
  currentType_gamme: any =[];
  currentModele: any = [];
  currentColor: any = [];
  private viewInsideAnswerId: any =[];
  private viewOutsideAnswerId: any=[];
  private hasInOrOutView: any=[];
 loadCatalog = true;
 isPageCatalogue = false;
 private rootCategoryType :any = ['GAMME'];
 showMultiProduct = false;
 public currentMultiProduct=[];
 public initProduct =0;
 currentIndexProduct = 0;
 public list_catalog : any = [];
 catalog_index =0;
 transformCss_w : any =[];
 standardMenu_answer = true;
 currentIndexCatalog = 0;
 listCatalogId = 0;
 catalogSlug = "porte";
 currentGroupId :any; 
 currentQuestionsGrpId:any;
 showMenuWindows = false;
 product_answers:any
 arrayProduct_index = 0;
 currentKeyword = "";
 answerProgress = false;
 currentModeleAnswerId:any;
 subTitleSelected = false;
 productSelected :any;
 simulateurActive = false;
 
  constructor(private http: HttpClient, private datePipe: DatePipe, private injector: Injector) {

    this.dataChangeSubject = new BehaviorSubject<string>(uuidv4());
    this.dataChange = this.dataChangeSubject.asObservable();
   
    this.currentUserAuthenticateSubject = new BehaviorSubject<UserAuthenticate>(this.userAuthenticate);
    this.currentUserAuthenticate = this.currentUserAuthenticateSubject.asObservable();
    localStorage.setItem('currentUserAuthenticate', JSON.stringify(this.userAuthenticate));
    localStorage.setItem('currentProduct', JSON.stringify(this.currentProduct));
    this.currentProductSubject = new BehaviorSubject<Product>(this.product);
    this.currentProduct = this.currentProductSubject.asObservable();
    this.questionsById = {};
    this.questionsByIdCode = {};
    this.limit_ = 25;

  }

  loadConfig(): Promise<void> {

    this.router = this.injector.get(Router);

    return this.http
      .get<HpServiceConfig>('./assets/data.json')
      .toPromise()
      .then(data => {

        this.config = data;
        this.configLoaded = true;
        var currentUrl = window.location.href;
        let isDev = false;
        let isPreprod = false;

        if (!isNaN(parseFloat(this.config.herculepro.breakPoint.widthPhone))) {
          this.breakPointWidthPhone = this.config.herculepro.breakPoint.widthPhone;
        }
        if (!isNaN(parseFloat(this.config.herculepro.breakPoint.heightPhone))) {
          this.breakPointHeightPhone = this.config.herculepro.breakPoint.heightPhone;
        }
        if (!isNaN(parseFloat(this.config.herculepro.breakPoint.widthTablet))) {
          this.breakPointWidthTablet = this.config.herculepro.breakPoint.widthTablet;
        }
        if (!isNaN(parseFloat(this.config.herculepro.breakPoint.heightTablet))) {
          this.breakPointHeightTablet = this.config.herculepro.breakPoint.heightTablet;
        }
        if (!isNaN(parseFloat(this.config.herculepro.breakPoint.WidthDkptMini))) {
          this.breakPointWidthDkptMini = this.config.herculepro.breakPoint.WidthDkptMini;
        }

        if (currentUrl.indexOf('localhost') > 0
          || currentUrl.indexOf('hpv.local.net') > 0) {
          isDev = true;
        } else {

          if (currentUrl.indexOf('preprod') > 0) {
            isPreprod = true;
          }
        }

         this.rootCategoryType[this.currentIndexProduct] = this.getConfig().herculepro.root_category_type;

        var robj = this.getConfig().herculepro.production;
        this.dataobj = this.getConfig().herculepro.production;
        this.showMultiProduct = this.getConfig().herculepro.showMultiProduct;
        if (isDev) {
          robj = this.getConfig().herculepro.dev;
          this.dataobj = this.getConfig().herculepro.dev;
        } else if (isPreprod) {
          robj = this.getConfig().herculepro.preprod;
          this.dataobj = this.getConfig().herculepro.preprod;
        }


        this.url_api = robj.api_url;
        this.api_username = robj.api_username;
        this.api_pwd = robj.api_pwd;
        this.callback_url_external_tool = robj.callback_url_external_tool;
        this.catId = encodeURIComponent(robj.api_cat_id);

        this.socNom = null;
        if (robj.api_soc_nom != null && robj.api_soc_nom != '') {
          this.socNom = encodeURIComponent(robj.api_soc_nom);
        }

        this.assetsPath = robj.assets_path;
        this.url_ambiance = 'assets/images/';
        this.hasDimension = this.getConfig().herculepro.hasDimension;
        this.startProduct = this.getConfig().herculepro.start_product;
        this.namePhoto_ext = this.getConfig().sample_outside;
        this.namePhoto_int = this.getConfig().sample_inside;
        this.pdfModelGuid = this.getConfig().herculepro.pdf_model_guid;
        this.dataMap = this.getConfig().data_googleMap;
       
        this.projectGuid = this.getRequestParam("projectGuid");

       //premier produit tableau multiProduit 
       this.productSelected = this.getConfig().herculepro.default_product;
        let isLineEdition = false;
        this.xParams = this.getRequestParam("data");
        var oPrms = { xParams: { external_tool: 0x10020 } };
        if (this.xParams != null && this.xParams != '') {
          try {
            oPrms = JSON.parse(this.xParams);
            var xp = oPrms['xParams'];
            if (xp && xp['projectGuid'] != null && xp['projectGuid'] != ''
              && xp['productGuid'] != null && xp['productGuid'] != '') {
              isLineEdition = true;
            }
          } catch (o) {
            console.log(o);
          }
        }
        oPrms.xParams['draw_output_mode_svg'] = 0;

        if (this.getConfig().herculepro.direct_access_parameters != null && !isLineEdition) {
          this.startDirectProductConfig[this.currentIndexProduct] = {};
          var hasVal = false;
          for (var k in this.getConfig().herculepro.direct_access_parameters) {
            var val = this.getRequestParam(this.getConfig().herculepro.direct_access_parameters[k]);
            if (val != null && val != '') {
              this.startDirectProductConfig[this.currentIndexProduct][k] = val;
              hasVal = true;
            }
          }
          if (!hasVal) {
            this.startDirectProductConfig[this.currentIndexProduct] = null;
          }
        }


        this.xParams = JSON.stringify(oPrms);

        if (this.catId != null && this.catId != ''
          && (this.startProduct != null && this.startProduct.id != null)
          ) {
          this.startProduct.catId = this.catId;
          this.questionsById[this.initProduct] = {};
          this.questionsByIdCode[this.initProduct] = {};
          this.setProduct(this.startProduct);
          this.doInitDirectProduct(0,0);

        } 
      });
  }

  init(): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      let data = {
        "user": this.api_username,
        "pass": this.api_pwd
      };
      this.app_loader = true;
      let url = "pass=" + this.api_pwd;
     /* if (this.socNom != null && this.socNom != '') {
        url += "&socId=" + this.socNom;
      }*/
      this.http.post<any>(this.url_api + "/rest/users/" + this.api_username + "/authenticate?" + url, data).subscribe(res => {
        let dataconfig = { "token": res.root.token }
        var url = this.url_api + "/rest/configurations/create?token=" + res.root.token;
        if (this.xParams != null && this.xParams != '') {
          url += "&data=" + encodeURIComponent(this.xParams);
        }

        if (this.projectGuid != null && this.projectGuid != '') {
          url += "&projectGuid=" + this.projectGuid;
        }
        if (this.productGuid != null && this.productGuid != '') {
          url += "&productGuid=" + this.productGuid;
        }
        this.http.post<any>(url, {}).subscribe(
          resData => {
            this.token = res.root.token;
            let auth = {
              "token": res.root.token,
              "configurationToken": resData.root.configurationToken,
              "elapsedTime": resData.root.elapsedTime
            }
            localStorage.setItem('currentUserAuthenticate', JSON.stringify(auth));
            this.currentUserAuthenticateSubject.next(auth);
            this.multiProductTokens.push(auth);
            let isLineEdition = false;
            if (resData.root.product != null && resData.root.product.length > 0) {
              if (resData.root.external_tool_data != null) {

                if (resData.root.external_tool_data.vueExt) {
                  this.restoreImage(resData.root.external_tool_data.vueExt, '0');
                }
                if (resData.root.external_tool_data.vueInt) {
                  this.restoreImage(resData.root.external_tool_data.vueInt, '1');
                }
              }
              this.setGlobaldata(resData);
              this.router.navigate(['simulateur-de-portes']);

              this.setAppLoader(false);
              this.setIsLoading(false);
              isLineEdition = true;
            } 
            //else {
              let url = this.url_api + "/rest/configuration/catalogues/" + this.catId + "/catalogue?token=" + this.multiProductTokens[0].token + "&configurationToken=" + this.multiProductTokens[0].configurationToken;
              this.http.get(url).subscribe(resData => {
                this.familles = resData;
                if (!isLineEdition) {
                  setTimeout(() => {
                    console.log('AppInitService Finished');
            
                    resolve();
                  }, 1000);
                }
              });
            //}
          });
      });
    });
  }

  getCurrentViewQuestion() {
    return this.currentViewQuestion[this.currentIndexProduct];
  }

  getRootCategoryType() {
    return this.rootCategoryType[this.currentIndexProduct];
  }

  getViewInsideAnswerId() {
    return this.viewInsideAnswerId[this.currentIndexProduct];
  }

  getViewOutsideAnswerId() {
    return this.viewOutsideAnswerId[this.currentIndexProduct];
  }


  getRequestParam(name: string) {
    var url_string = window.location.href;
    var url = new URL(url_string);
    var paramValue = url.searchParams.get(name);
    return paramValue;
  }

  getAssetsFullPath() {
    return this.url_api + this.assetsPath;
  }

  getIsLoading() {
    return this.is_loading;
  }

  setIsLoading(isLoading: boolean) {
    this.is_loading = isLoading;
  }

  getMultiDataForPrinting() {

    var oData = this.getMultiGlobaldata();
    debugger;
    if (oData == null || oData.length == 0) {
       oData[0] = {};
    }

    return oData;
  }

  getCurrentSimulationData() {

    var oData = this.getMultiDataForPrinting();
    var result = {
      "products" : [],
      "options" : []
    };
    if (oData != null && oData.length > 0) {

      for (var i = 0; i < oData.length; i++) {

        var product = {
          idx : i,
          name : 'catalogs__' + i
        }
        result.products.push(product);

        var o = this.questionsById[i];
        for (var k in o) {

          var question = o[k];
          if (question.answers && question.answers.length > 0) {
            var a = question.answers[0];
            if (a.label != null && a.label != '') {
              var oo = {
                code: question.code,
                label_answer: a.label,
                cidx : i
              }
              result.options.push(oo);
              //sresult.push(oo);
              oo = {
                code: 'IMG_' + question.code,
                label_answer: this.url_api + '/fdw/' + a.drawimg,
                cidx : i
              }
              result.options.push(oo);
            }

          }
        }
      }
    }
    return result;
  }

  getPdfModelGuid() {
    return this.pdfModelGuid;
  }

  getAssetsPath() {
    return this.assetsPath;
  }

  getDataChange() {
    return this.dataChange;
  }

  getConfig(): HpServiceConfig {
    return this.config;
  }

  public getProductId() {
    debugger
    if(this.showMultiProduct)
    {
       return this.multiGlobalData[this.currentIndexProduct].root.product[0].id;
    }
    else{
      return this.currentProductValue.id;
      
    }
  }
  public setProductId() {
      
    if(this.showMultiProduct)
    {
      this.currentProductValue.id = this.multiGlobalData[this.currentIndexProduct].root.product[0].id;
    }
    else
    {
      this.currentProductValue.id = this.multiGlobalData[0].root.product[0].id;
    }

  }

  public get currentUserValue(): UserAuthenticate {
    return this.currentUserAuthenticateSubject.value;
  }

  public get userValue(): UserAuthenticate {
    return this.userAuthenticate;
  }

  public get currentProductValue(): Product {
    return this.currentProductSubject.value;
  }

  public get productValue(): Product {
    return this.product;
  }



  restoreImage(img: any, vueType: any) {
    var prevVue = this.vue;
    this.vue = vueType;
    if (isNaN(parseFloat(img))) {
      if (vueType == '0') {
        this.setIsUploadExt(true);
      } else if (vueType == '1') {
        this.setIsUploadInt(true);
      }

      this.setTypeVisuel('upload-0');
    } else {
      this.setTypeVisuel('view-0');
    }
    this.setImageName(img);

    this.vue = prevVue;
    this.emitDataChange();
  }

  public saveProject(extPersistedData: any) {

    if (extPersistedData != null && extPersistedData != '') {

      const body = new HttpParams({ fromObject: extPersistedData });
      const headers2 = new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      });
      let options = {
        headers: this.headers
      };
      return this.http.post<any>(this.url_api + `/rest/configuration/produit/saveAsPost`
        + `?token=` + this.token + "&configurationToken=" + this.currentUserValue.configurationToken,
        "valuesData=" + encodeURIComponent(JSON.stringify(extPersistedData)), options);
    } else {
      return this.http.get<any>(this.url_api + `/rest/configuration/produit/save` + `?token=` + this.token + '&configurationToken=' + this.currentUserValue.configurationToken);
    }
  }

  private receiveExternalMessage(event: any) {

    if (event && event.data && event.data.type
      && this.callback_url_external_tool != null
      && this.callback_url_external_tool != ''
      && (event.origin == this.callback_url_external_tool
        || event.origin == "null")
    ) {
      var msg = event.data.type;
      console.log("Inner msg received : " + msg);
    }
  }

  public postExternalMessage(message: string, data: any) {
    if (this.callback_url_external_tool != null
      && this.callback_url_external_tool != '' && window.parent) {

      var postData = {
        type: message
      }
      if (data != null) {
        postData['data'] = data;
      }
      try {
        window.parent.postMessage(postData, '*');
      } catch (e) {
        console.log(e);
      }
    }
  }


  initSelecteurPorte() {

    if (this.getConfig().herculepro.has_not_filter) {
      this.app_loader = false;
      return;
    }
    this.searchModele(this.catId, this.getConfig().herculepro.search_parameters_default).subscribe({
      next: (data) => {

        for (let i = 0; i < data.root.data.length; i++) {
          let item = {
            "id": data.root.data[i][0],
            "keywords": data.root.data[i][1],
            "name": data.root.data[i][2],
            "image": data.root.data[i][3]
          }
          this.panneaux.push(item);
        }

        this.setAppLoader(false);
      },
      error: (error) => {
        console.log('error'); // Pas reponse de tout  avec erreur
      }
    });
  }

  /*
  HP SERVICES
  */
  public getCataloghp() {
    return this.hp_catalogue;
  }

  /**
   *
   * @param catId
   * @returns Liste de catalogues
   */
  public fetchOnlyOneCatalogue(catId: any): Observable<any> {
    let tokenUrl = (this.showMultiProduct) ? "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken :
      "?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken
      ;

    let url = this.url_api + "/rest/configuration/catalogues/" + catId + "/catalogue" + tokenUrl;
    return this.http.get(url);
  }
  /**
   *
   * @param catId
   * @returns Les familles
   */
  public fetchFamilles(catId: any, params: any): Observable<any> {
    let tokenUrl = (this.showMultiProduct) ? "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken :
      "?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken
      ;

    let famId = encodeURIComponent(params);
    let url = this.url_api + "/rest/configuration/catalogues/" + catId + "/" + famId + "/familles" + tokenUrl;
    this.hp_paramaters = famId;

    return this.http.get(url);

  }
  /**
  *
  * @param catId
  * @param famId
  * @returns Les sous  familles leaf =false
  */

  public fetchSousFamilles(catId: any, params: any): Observable<any> {
    let tokenUrl = (this.showMultiProduct) ? "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken :
      "?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken
      ;

    let url = this.url_api + "/rest/configuration/catalogues/" + catId + "/familles/" + this.hp_paramaters + tokenUrl;
    return this.http.get(url);

  }

  /**
   *
   * @param catId
   * @param famId
   * @returns liste des produits
   */
  public fetchProducts(catId: any, params: any): Observable<any> {
    let tokenUrl = (this.showMultiProduct) ? "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken :
      "?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken
      ;

    let url = this.url_api + "/rest/configuration/catalogues/" + catId + "/familles/" + params + "/produits" + tokenUrl;
    this.reqUrl = url;
    return this.http.get(url);

  }
  /**
   *
   * @param catId
   * @param famId
   * @returns liste des produits de sous famille
   */

  public fetchSousFamilleProducts(catId: any, params: any): Observable<any> {
    let id = encodeURIComponent(params);
    let tokenUrl = (this.showMultiProduct) ? "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken :
      "?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken
      ;

    let url = this.url_api + "/rest/configuration/catalogues/" + catId + "/familles/" + id + "/produits" + tokenUrl;
    this.reqUrl = url;
    return this.http.get(url);

  }

  public fetchOneProduct(catId: any, prodId: any, resetProduct : boolean): Observable<any> {
   console.log[this.currentIndexProduct]
    let data = {
      "catId": catId,
      "prodId": prodId
    }

    let tokenUrl = (this.showMultiProduct) ? "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken :
      "?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken;

    let url = this.url_api + "/rest/configuration/produit/" + catId + "/" + prodId + tokenUrl

    if (this.xParams != null && this.xParams != '' && !resetProduct) {
      url += "&data=" + encodeURIComponent(this.xParams);
    }

    return this.http.put(url, data);

  }

  public setProduct(product: any) {
    localStorage.setItem('currentProduct', JSON.stringify(product));
    this.currentProductSubject.next(product);
  }

  public setInitProduct(productId: any) {
    this.initProductId = productId
  }
  public getInitProduct() {
    return this.initProductId;
  }
  public setDefaultProduct(productId: any) {
    this.defaultProduct = productId
  }
  public getDefaultProduct() {
    return this.defaultProduct;
  }

  /*
  Liste de reponse -coloris
  */
  /*
   public fetchColors(catId: any, prodId: any, id: any): Observable<any> {
     let url = this.url_api + "/rest/configuration/produit/" + catId + "/" + prodId + "/elements/0/questions/" + id + "/reponses?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken;
 
     return this.http.get(url);
 
   }
   */

  public fetchAnswers(catId: any, prodId: any, code: any, elementId: any) {
    let tokenUrl = (this.showMultiProduct) ? "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken :
      "?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken;
    let url = this.url_api + "/rest/configuration/produit/" + this.getCatId() + "/" + prodId + "/elements/" + elementId + "/questions/" + code + "/reponses" + tokenUrl;
    return this.http.get(url);
  }
  public fetchProductAnswers(catId: any, prodId: any, code: any, elementId: any) {
    let tokenUrl = (this.showMultiProduct) ? "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken :
    "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken;
    let url = this.url_api + "/rest/configuration/produit/" + this.getCatId() + "/" + prodId + "/elements/" + elementId + "/questions/" + code + "/reponses" + tokenUrl;//this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken;
    return this.http.get(url);
  }

  /**
   *
   * @param catId
   * @param prodId
   * @param idElement
   * @param variableId
   *  @returns
   */
  fetchCoteProd(catId: any, prodId: any, idElement: any, var_hId: any, valueH: any, var_lId: any, valueL: any) {

    let data = {};
    let variables = var_hId + "," + var_lId + "/" + valueH + "," + valueL;
    let tokenUrl = (this.showMultiProduct) ? "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken :
      "?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken;
    let url = this.url_api + "/rest/configuration/produit/" + catId + "/" + prodId + "/elements/" + idElement + "/variables/" + variables + tokenUrl;
    return this.http.put(url, data);
  }

  /**
   *
   * @param catId
   * @param prodId
   * @param idElement
   * @param variableId reponse
   *  @returns
   */
  putVariablesValues(catId: any, prodId: any, idElement: any, identifiantQuestion: any, identifiantReponse: any, idVariable: any, valueVariable: any) {
    let data = {};
    let url = null;
    let tokenUrl = (this.showMultiProduct) ? "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken :
      "?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken;
    if (identifiantQuestion == null || identifiantReponse == null) {
      url = this.url_api + "/rest/configuration/produit/" + catId + "/" + prodId + "/elements/" + idElement + "/variables/" + encodeURIComponent(idVariable) + "/" + valueVariable
        + tokenUrl;
    } else {
      url = this.url_api + "/rest/configuration/produit/" + catId + "/" + prodId + "/elements/" + idElement + "/questions/" + identifiantQuestion + "/reponses/" + identifiantReponse + "/variables/" + idVariable + "/" + valueVariable
        + tokenUrl;
    }
    return this.http.put(url, data);
  }

  putMultipleAnswersSelected(catId: any, prodId: any, idElement: any, identifiantsReponses: any) {
    let tokenUrl = (this.showMultiProduct) ? "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken :
      "?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken;
    let data = {};
    let url = this.url_api + "/rest/configuration/produit/" + this.catId + "/" + prodId + "/elements/" + idElement +
      "/multi_reponses/" + identifiantsReponses + tokenUrl;
    return this.http.put(url, data);
  }

  putAnswerSelected(catId: any, prodId: any, idElement: any, identifiantQuestion: any, identifiantReponse: any, idVariable: any, valueVariable: any) {
    let data = {};
    this.loadCatalog = false;
    let tokenUrl = (this.showMultiProduct) ? "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken :
      "?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken;

    let url = this.url_api + "/rest/configuration/produit/" + this.catId + "/" + prodId + "/elements/" + idElement + "/questions/"
      + identifiantQuestion + "/reponses/" + identifiantReponse + tokenUrl;
    return this.http.put(url, data);
  }

  putAnswerSelectedByCodes(catId: any, prodId: any, idElement: any, idCodeCategory: any, idCodeAnswer: any) {
    let data = {};
    let tokenUrl = (this.showMultiProduct) ? "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken :
      "?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken;
    let url = this.url_api + "/rest/configuration/produit/" + this.catId + "/" + prodId + "/elements/" + idElement
      + "/questionsByCode/" + encodeURIComponent(idCodeCategory) + "/reponsesbyCode/" + encodeURIComponent(idCodeAnswer)
      + tokenUrl;
    return this.http.put(url, data);
  }


  fetchPrice(catId: any, prodId: any, w: any, h: any, data: any) {
    let tokenUrl = (this.showMultiProduct) ? "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken :
      "?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken;

    let url = this.url_api + "/rest/configuration/produit/" + catId + "/" + prodId + "/elements/0/variables/L/" + w + tokenUrl;

    return this.http.put(url, data);
  }

  searchModele(catalogInfo: any, searchParams: string): any {
    let tokenUrl = (this.showMultiProduct) ? "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken :
      "?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken
    let url = this.url_api + "/rest/configuration/search_simuleo_modele/" + catalogInfo + tokenUrl + "&searchParams=" + encodeURIComponent(searchParams);
    return this.http.get(url);
  }


  putFormMultipleActions(catId: any, prodId: any, idElement: any, formLibs: any) {
    let data = {};
    let url = this.url_api + "/rest/configuration/produit/" + this.catId + "/" + prodId + "/elements/" + idElement
      + "/direct_put_simuleo_multiple_actions/" + encodeURIComponent(formLibs)
      + "?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken;
    return this.http.put(url, data);
  }

  autoPositionActions(formLibs, fnCallBack, scope) {
    this.setIsLoading(true);
    this.putFormMultipleActions(this.getCatId(), this.getRootProductId(), this.getRootProductElt(), formLibs).subscribe({
      next: (data: any) => {

        this.setAppLoader(false);
        this.setIsLoading(false);
        this.setGlobaldata(data);
        if (fnCallBack != null) {
          fnCallBack.call(scope);
        }
      },
      error: (error) => {
        console.log('error');
        this.setIsLoading(false);
        this.setAppLoader(false);
      }

    });
  }



  formatWord(word) {
    word = word.replace(/[^a-zA-Z0-9]/g, '_');
    word = word.toLowerCase();
    return word;
  }

  public getOvConfigCat() {
    return this.ovConfigCat[this.currentIndexProduct];
  }

  getRequestUrl() {
    return this.reqUrl;
  }


  setParameters(params: any) {
    this.hp_paramaters = params;
  }
  getParameters() {
    return this.hp_paramaters;
  }


  hasKeywords(obj: any, keyword: string) {
    if (obj != null && obj.kwsInterpreted != null) {

      for (var k in obj.kwsInterpreted) {
        if (k == keyword) {
          return true;
        }
      }
    }
    return false;
  }


  hasKeywordsStartingWith(obj: any, keyword: string) {

    if (obj != null && obj.kwsInterpreted != NullAstVisitor) {

      for (var k in obj.kwsInterpreted) {
        if (k.startsWith(keyword)) {
          return true;
        }
      }
    }
    return false;
  }

  getFirstKeyword(obj: any) {
    if (obj != null && obj.kwsInterpreted != null) {

      for (var k in obj.kwsInterpreted) {
        return k;
      }
    }
    return null;
  }

  getFirstKeywordStartingWith(obj: any, keyword: string) {
    if (obj != null && obj.keywords &&
      obj.kwsInterpreted != null) {

      for (var k in obj.kwsInterpreted) {

        if (k.startsWith(keyword)) {
          return k;
        }

      }
    }
    return null;
  }

  doInterpretKeywords(keywords: string) {
    if (keywords != null && keywords != '') {
      var ls = keywords.split(",");

      var result = {};
      for (var i = 0; i < ls.length; i++) {
        if (ls[i] != null && ls[i].trim() != '') {
          result[ls[i].trim()] = '1';
        }
      }
      return result;
    }
    return null;
  }

  getUseDisplayBySubItems() {
    if (this.getConfig().herculepro.tierce_system == null) {
      return true;
    } else {
      return this.getConfig().herculepro.tierce_system;
    }

  }

  setGlobaldata(data: any) {
   
    this.globalData = data; 
   if(this.config.herculepro.multiProduct) 
   {
    this.globalDataLoaded = data;
   }
   if(this.loadCatalog && this.config.herculepro.multiProduct)
    {
    this.multiGlobalData.push(data);
    }
    else
    {
      this.multiGlobalData[this.currentIndexProduct]={}
      this.multiGlobalData[this.currentIndexProduct]=data;
  
      for (var i = 0; i < this.getCloneControle().length; i++) {
        
        if(this.getCloneControle()[i].idModele === this.currentModeleAnswerId)
          {
            this.multiGlobalData[i]={}
            this.multiGlobalData[i]=data;
          }
            
      }

    }
    this.hiddenQuestions[this.currentIndexProduct]  = {};
    this.subQuestions[this.currentIndexProduct]  = {};
    this.topQuestions[this.currentIndexProduct] = {};
    this.ovConfigCat[this.currentIndexProduct] = {};
    this.questionsViewStockable[this.currentIndexProduct] = {};
    this.tpSubQuestions[this.currentIndexProduct]  = {};
    this.ovConfigCat[this.currentIndexProduct] = null;

    if (this.globalData.root.ov_cat_config != null) {
      if (this.globalData.root.ov_cat_config.simuleoInfos != null) {
        this.ovConfigCat[this.currentIndexProduct] = this.globalData.root.ov_cat_config.simuleoInfos;
      }
    }
if( this.config.herculepro.multiProduct)
  {
    this.multiGlobalData[this.currentIndexProduct].root.product[0].kwsInterpreted = this.doInterpretKeywords(this.multiGlobalData[this.currentIndexProduct].keywords);
  }
  else
  {
    this.globalData.root.product[0].kwsInterpreted = this.doInterpretKeywords(this.globalData.root.product[0].keywords);
 
  }
  var globalProduct =this.config.herculepro.multiProduct ? this.multiGlobalData[this.currentIndexProduct].root.product[0] : this.globalData.root.product[0];

    globalProduct.hasImposte = false;
    globalProduct.hasLeftTierce = false;
    globalProduct.hasRightTierce = false;

    if (this.hasKeywords(globalProduct, 'SYS.IMPOSTE')) {
      globalProduct.hasImposte = true;
    }
    if (this.hasKeywords(globalProduct, 'SYS.TIERCE.G')) {
      globalProduct.hasLeftTierce = true;
    }
    if (this.hasKeywords(globalProduct, 'SYS.TIERCE.D')) {
      globalProduct.hasRightTierce = true;
    }

    var groups = this.globalData.root.product[0].groups;
    var grp = null;

    for (var name in groups) {
      grp = groups[name];
      grp.kwsInterpreted = this.doInterpretKeywords(grp.keywords);
      grp.className = this.formatKeywordAsClassName(this.getFirstKeyword(grp));
      if (grp.questions) {
        let i = grp.questions.length;
        let question = null;
        while (i--) {
          question = grp.questions[i];
          question.grpId = name;
          question.kwsInterpreted = this.doInterpretKeywords(question.keywords);

          if (this.hasKeywords(question, 'CART_ID.CODE.OUVERTURE')) {
           this.currentType_ouverture[this.currentIndexProduct] = question;
          }
          if (this.hasKeywords(question, 'CART_ID.CODE.MATIERE')) {
            this.currentMatiere[this.currentIndexProduct] = question;
          }
          if (this.hasKeywords(question, 'CART_ID.CODE.GAMME')) {
            this.currentType_gamme[this.currentIndexProduct] = this.hasKeywords(question, 'CART_ID.CODE.TYPE_DE_GAMME') ? this.currentType_gamme : question;
            this.currentGamme[this.currentIndexProduct] = question;
          }
       
          if (this.hasKeywords(question, 'CART_ID.CODE.TYPE_DE_GAMME')) {
          //this.currentGamme [this.currentIndexProduct]  = this.hasKeywords(question, 'CART_ID.CODE.GAMME') ? this.currentGamme : question;
            this.currentType_gamme[this.currentIndexProduct]  = question;
          }
          if (this.hasKeywords(question, 'CART_ID.CODE.TYPE_DE_VITRAGE')) {
            this.currentVitrage_type[this.currentIndexProduct]  = question;
          }
          if (this.hasKeywords(question, 'CART_ID.CODE.MODELE')) {
            this.currentModele[this.currentIndexProduct]  = question;
            this.currentElement_type[this.currentIndexProduct]  = question
            
          }
          if (this.hasKeywords(question, 'CART_ID.CODE.COULEUR')) {
            this.currentColor[this.currentIndexProduct]  = question;
          }

          if (this.hasKeywords(question, 'CART_ID.CODE.FORME')) {
            this.currentForme[this.currentIndexProduct]  = question;
          }

          if (this.hasKeywords(question, 'SYS.VUE.STOCKABLE')) {
            this.questionsViewStockable[this.currentIndexProduct][question.id] = question;
          }

          if (this.hasKeywords(question, 'CART_ID.CODE.TYPE_DE_VUE')) {
            this.currentViewQuestion[this.currentIndexProduct]  = question;
          }

          if (this.hasKeywords(question, 'SYS.SIM.C.HIDDEN')) {
            var res = grp.questions.splice(i, 1);
            this.hiddenQuestions[this.currentIndexProduct][String(res[0].code)] = res;

          } else if (this.hasKeywordsStartingWith(question, 'SYS.SIM.TITLE')) {
            question.hasSysSimTitle = true;
            var kwd = this.getFirstKeywordStartingWith(question, 'SYS.SIM.TITLE');
            var res = grp.questions.splice(i, 1);
            res[0].is_sub_title = true;
            this.tpSubQuestions[this.currentIndexProduct][kwd] = res;
          }
          this.questionsById[this.currentIndexProduct][String(question.id)] = question;
          var idCodeKw = this.getFirstKeywordStartingWith(question, 'CART_ID.CODE.');
          if (idCodeKw != null) {
            idCodeKw = idCodeKw.replace('CART_ID.CODE.', '');
            this.questionsByIdCode[this.currentIndexProduct][idCodeKw] = question;
          }
        }
      }
    }

    if (Object.keys(this.tpSubQuestions[this.currentIndexProduct]).length > 0) {
      for (var k in this.tpSubQuestions[this.currentIndexProduct]) {
        var o = this.tpSubQuestions[this.currentIndexProduct][k];
        k = k.replace('SYS.SIM.TITLE.', '');
        for (var l in this.questionsById[this.currentIndexProduct]) {
          var m = this.questionsById[this.currentIndexProduct][l];
          if (m.code == k) {
            m.is_title = true;
            this.subQuestions[this.currentIndexProduct][l] = o[0].id;
            this.topQuestions[this.currentIndexProduct][o[0].id] = m.id;
       
            break;
          }
        }
      }
    }

    for (var k in groups) {
      var grp = groups[k];
      if (grp.questions == null
        || grp.questions.length == 0) {
        delete groups[k];
      }
    }

    for (var k in groups) {
      var grp = groups[k];
      var qsts = grp.questions;
      var ls = []
      for (var kqst in grp.questions) {
        var qst = grp.questions[kqst];
        if (!this.hasKeywords(qst, 'SYS.SIM.C.HIDDEN.WEXEC')) {
          ls.push(qst);
        }
      }
      grp.visibleQuestions = ls;
    }


    this.currentProductValue.id = this.globalData.root.product[0].id;
    this.hasInOrOutView[this.currentIndexProduct] = false;
    this.viewOutsideAnswerId[this.currentIndexProduct] = null;
    this.viewInsideAnswerId[this.currentIndexProduct] = null;
    if (this.hiddenQuestions[this.currentIndexProduct]['TYPE_DE_VUE']) {
      this.fetchAnswers(this.getCatId(), this.startProduct.id, this.hiddenQuestions[this.currentIndexProduct]['TYPE_DE_VUE'][0].id, this.getRootProductElt()).subscribe(data => {
        let me = this;
        if (data && data['root'] && data['root']['data']) {
          var views = data['root']['data'];
          if (views && views.length > 0) {
            var v = null;
            for (var i = 0; i < views.length; i++) {
              v = views[i];
              if (v && v.keywords) {
                v.kwsInterpreted = me.doInterpretKeywords(v.keywords);
                if (me.hasKeywords(v, 'SYS.VUE.EXT')) {
                  me.viewOutsideAnswerId[me.currentIndexProduct] = v.id;
                  this.emitDataChange();
                } else if (me.hasKeywords(v, 'SYS.VUE.INT')) {
                  me.viewInsideAnswerId[me.currentIndexProduct] = v.id;
                  this.emitDataChange();
                }
              }
            }

            //VA 29.12.2023 - ici on vérifie la presence des mots clés "SYS.VUE.INT" et/ou "SYS.VUE.EXT"
            //la configuration de la bibliothèque va indiquer si les deux reponses de type de vue sont presentes ou non
            //et leur presence indique si le produit dispose de vues exterieurs / interieurs, ou juste exterieur
            if (me.viewOutsideAnswerId[me.currentIndexProduct] != null && me.viewOutsideAnswerId[me.currentIndexProduct] != ''
              && me.viewInsideAnswerId[me.currentIndexProduct] != null && me.viewInsideAnswerId[me.currentIndexProduct] != '') {
              me.hasInOrOutView[me.currentIndexProduct] = true;
              this.emitDataChange();
            }

          
                     
          }
        }
        var view = "0";
        if (me.getCurrentView() != null) {
          var ans = me.getCurrentView();
          if (ans != null) {
            if (ans.kwsInterpreted == null) {
              ans.kwsInterpreted = me.doInterpretKeywords(ans.keywords);
            }
            if (me.hasKeywords(ans, 'SYS.VUE.INT')) {
              view = "1";
            }
          }
        }
        me.setView(view);
      });

    } else if (this.hasKeywords(globalProduct, 'SYS.FORCE.MULTIVIEWS')) {
      this.hasInOrOutView[this.currentIndexProduct] = true;
      this.setView("0");
    }
  
    if(this.hasInOrOutView)
      {
        this.setView("0");
      }
    this.emitDataChange();
  }

  getQuestionsViewStockable() {
    return this.questionsViewStockable[this.currentIndexProduct];
  }

  /*
  getQuestionsViewStockableForInsideView() {
    return this.questionsViewStockableForInsideView;
  }

  getQuestionsViewStockableForOutsideView() {
    return this.questionsViewStockableForOutsideView;
  }
  */

  setCurrentViewStockableAnswers(currentSelections: any, isInsideView: boolean) {

    if (this.stockableAnswers[this.currentIndexProduct] == null) {
      this.stockableAnswers[this.currentIndexProduct] = {};
    }
    var key = 'outside';
    if (isInsideView == true) {
      key = 'inside';
    }
    this.stockableAnswers[this.currentIndexProduct][key] = currentSelections;
  }

  getCurrentViewStockableAnswers(isInsideView) {
    if (this.stockableAnswers[this.currentIndexProduct] != null) {
      var key = 'outside';
      if (isInsideView == true) {
        key = 'inside';
      }
      return this.stockableAnswers[this.currentIndexProduct][key];
    }
    return null;
  }

  getHasInOrOutView() {
    return this.hasInOrOutView[this.currentIndexProduct];
  }

  getCategoryById(id: any) {
    return this.questionsById[this.currentIndexProduct][id];
  }

  getCategoryByIdCode(idCode) {

    var result = null;
    if (this.questionsByIdCode[this.currentIndexProduct] != null
      && this.questionsByIdCode[this.currentIndexProduct][idCode] != null) {

      return this.questionsByIdCode[this.currentIndexProduct][idCode];

    }
  }

  getVisibleQuestions(group: any) {
    if (group != null && group.value && group.value.visibleQuestions
      && group.value.visibleQuestions.length > 0) {
      return group.value.visibleQuestions;
    }
    return group.value.questions;
  }

  /**
   * get default color
   */

  initDefaultCoulor() {
    var groups = this.globalData.root.product[0].groups;
    var grp = null;
    for (var name in groups) {
      grp = groups[name];
      grp.kwsInterpreted = this.doInterpretKeywords(grp.keywords);
      grp.className = this.formatKeywordAsClassName(this.getFirstKeyword(grp));

      if (grp.questions) {
        let i = grp.questions.length;
        let question = null;
        while (i--) {
          question = grp.questions[i];
          question.kwsInterpreted = this.doInterpretKeywords(question.keywords);
          if (this.hasKeywords(question, 'COULEUR')) {
            this.default_couleur[this.currentIndexProduct] = grp.questions[i];
          }

        }
      }
    }

  }
  getDefaultCoulor(): any {
    return this.default_couleur[this.currentIndexProduct];
  }
  emitDataChange() {
    setTimeout(() => {
      this.dataChangeSubject.next(uuidv4());
    }, 50);
  }

  formatKeywordAsClassName(srcKeyword: string) {
    if (srcKeyword != null && srcKeyword != '') {
      let re = /\./gi;
      let keyword = srcKeyword.replace(re, "-");
      keyword = keyword.replace(/ /g, '');
      return keyword.toLowerCase();
    }
    return null;
  }

  getkeywordsArrayForQuery(keyword: string) {

    var keywords = this.doInterpretKeywords(keyword);
    var kws = [];
    for (var k in keywords) {
      kws.push(k.toLocaleLowerCase());
    }
    return kws;
  }

  getInfo() {
    return null;
  }

  getSlug() {
    return this.config.herculepro.slug;
  }

  getLinkedSubQuestionId(questionId: any) {
    if (this.subQuestions[this.currentIndexProduct] != null && this.subQuestions[this.currentIndexProduct][questionId] != null) {
      return this.subQuestions[this.currentIndexProduct][questionId];
    }
  }

  getLinkedTopQuestionId(questionId: any) {
    if (this.topQuestions[this.currentIndexProduct] != null && this.topQuestions[this.currentIndexProduct][questionId] != null) {
      return this.topQuestions[this.currentIndexProduct][questionId];
    }
  }

  public getQuestionIsTitle(questionId) {
    if (this.questionsById[this.currentIndexProduct] != null && this.questionsById[this.currentIndexProduct][questionId] != null) {
      return this.questionsById[this.currentIndexProduct][questionId].is_title;
    }
    return false;
  }

  public getQuestionIsSubTitle(questionId) {
    if (this.questionsById[this.currentIndexProduct] != null && this.questionsById[this.currentIndexProduct][questionId] != null) {
      return this.questionsById[this.currentIndexProduct][questionId].is_sub_title;
    }
    return false;
  }

  getHiddenQuestions() {
    return this.hiddenQuestions[this.currentIndexProduct];
  }

  /**
   * 
   * @returns current view
   */
  getCurrentView() {
    if (this.currentViewQuestion[this.currentIndexProduct] != null
      && this.currentViewQuestion[this.currentIndexProduct].answers
      && this.currentViewQuestion[this.currentIndexProduct].answers.length > 0) {
      return this.currentViewQuestion[this.currentIndexProduct].answers[0];
    }
    return null;
  }

  getWidthMini() {
    var v = this.getGlobalVarProperty('L', true, 'var_min_val');
    if (v == null) {
      v = 200;
    }
    return v;
  }

  getWidthMaxi() {
    var v = this.getGlobalVarProperty('L', true, 'var_max_val');
    if (v == null) {
      v = 2000;
    }
    return v;
  }

  getHeightMini() {
    var v = this.getGlobalVarProperty('H', true, 'var_min_val');
    if (v == null) {
      v = 500;
    }
    return v;
  }

  getHeightMaxi() {
    var v = this.getGlobalVarProperty('H', true, 'var_max_val');
    if (v == null) {
      v = 3000;
    }
    return v;
  }


  getWidth() {
    var v = this.getGlobalVarProperty('L', true, 'var_value');
    if (v == null) {
      v = 1000;
    }
    return v;
  }

  getHeight() {
    var v = this.getGlobalVarProperty('H', true, 'var_value');
    if (v == null) {
      v = 2000;
    }
    return v;
  }

  getGlobalVarByCode() {

  }

  hasProductLoaded() {
    if (this.getRootProduct() != null) {
      return true;
    }
    return null;
  }

  hasGlobalVars() {

    var allVars = this.getGlobalVars();
    if (allVars != null && allVars.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  getGlobalVars() {

    if (this.getRootProduct() != null) {
      if (this.getRootProduct().global_vars
        && this.getRootProduct().global_vars.variables
        && this.getRootProduct().global_vars.variables.length > 0) {
        return this.getRootProduct().global_vars.variables;
      }
    }
    return null;
  }

  //dans le cas ou l'on accède au simulateur directement au niveau du produit
  //sans passer par la selection de familles.
  public doInitDirectProduct(index_,currentProduct) {
    var me = this;

    this.init().then(function (result) {

      if ((me.productGuid == null || me.productGuid == '')
        && (me.projectGuid == null || me.projectGuid == '')) {
          me.fetchOneProduct(me.getCatId(), me.startProduct.id, true).subscribe(data => {
          me.setGlobaldata(data);
          if (me.startDirectProductConfig[me.currentIndexProduct] != null) {
            var items = [];
            for (var k in me.startDirectProductConfig[me.currentIndexProduct]) {
              items.push(me.startDirectProductConfig[me.currentIndexProduct][k]);
            }
            me.selectItems(items, me.onDirectSelectItemsDone, me);
          } else {
            me.initDefaultCoulor();
            me.initSelecteurPorte();
          }
          if(me.isMultiProducts && me.config.herculepro.multiProduct)
          {
           me.loadProduct(index_,currentProduct);
          } 
         /* let clone = {"parentIndex":me.currentIndexProduct,"isClone":false}
          me.cloneControle.push(clone); */

        });
      }
    });
  }

  private onDirectSelectItemsDone() {
    var me = this;
    me.router.navigate(['simulateur-de-portes']);
  }

  public selectItem(itemLabel, fnCallback, scope){


    return new Promise<void>((resolve, reject) => {
      this.selectItems([itemLabel], fnCallback, scope);
       
           setTimeout(() => {
          console.log('upadate modele Finished' + this.currentIndexProduct);
          this.emitDataChange();
          resolve();
        }, 1000);
      });
   
    

  }

  public selectItems(listOfStringItems, fnCallback, scope) {
    this.setAppLoader(true);
    this.directSelectMultipleItems.call(this, this.getCatId(),
      this.getRootProductId(), this.getRootProductElt(), listOfStringItems).subscribe({
       
        next: (data: any) => {
          this.setAppLoader(false);
          this.emitDataChange();
          try {
           
              this.setGlobaldata(data);
              this.emitDataChange();
              
              console.log(data);
            

          } catch (o) { }

          if (fnCallback != null) {
            fnCallback.call(scope);
          }
          this.emitDataChange();
        },
        error: (error) => {
          console.log('error');
          this.setAppLoader(false);
        }
      });
      this.emitDataChange();
  }

  directSelectMultipleItems(catId: any, prodId: any, idElement: any, itemLabels: any) {
    let data = {};
    //VERT_TEXTURE,POIGNEE_DE_TIRAGE_RONDE_GRIS

    var labels = '';
    for (var i = 0; i < itemLabels.length; i++) {
      labels += itemLabels[i] + ',';
    }
    labels = labels.substring(0, labels.length - 1);
    let tokenUrl = (this.showMultiProduct) ? "?token=" + this.multiProductTokens[this.currentIndexProduct].token + "&configurationToken=" + this.multiProductTokens[this.currentIndexProduct].configurationToken :
    "?token=" + this.currentUserValue.token + "&configurationToken=" + this.currentUserValue.configurationToken;
    let url = this.url_api + "/rest/configuration/produit/" + this.getCatId() + "/" + prodId + "/elements/" + idElement
      + "/direct_put_simuleo_multiple_items/" + encodeURIComponent(labels)
      +  tokenUrl;
    return this.http.put(url, data);
  }


  //cette methode va retourner la liste des questions 
  getGroups(): any {
    return this.getAllGroups();
  }

  getAllGroups() {
    if (this.getRootProduct() != null) {
      return this.getRootProduct().groups;
    }
    return null;
  }

  getGroupById(groupId) {
    var groups = this.getAllGroups();
    if (groups != null) {
      return groups[groupId];
    }
    return null;
  }

  getRootProductElt() {
    if (this.getRootProduct() != null) {
      return this.getRootProduct().elt;
    }
    return null;
  }

  getRootProductKeywords() {
    if (this.getRootProduct() != null) {
      return this.getRootProduct().kwsInterpreted;
    }
    return null;
  }

  getDrawing() {
    let root_ = (this.globalData && this.globalData.root && this.globalData.root.product && this.globalData.root.product.length > 0) ? this.globalData.root.product[0] : null;
    if (root_) {
      return this.globalData.root.drawing.value;
    }
    return null;
  }

  getItemPropertyByCode(list, code, propCode, propertyName) {
    for (var i = 0; i < list.length; i++) {
      var obj = list[i];
      if (obj[propCode] == code) {
        return obj[propertyName];
      }
    }
  }


  getGlobalVarProperty(varCode, byDimCode, propertyName) {
    var result = null;
    var globalVars = this.getGlobalVars();
    if (globalVars != null) {
      var propCode = 'var_id';
      if (byDimCode) {
        propCode = 'var_dim_code';
      }
      result = this.getItemPropertyByCode(globalVars, varCode, propCode, propertyName);
    }
    if (result == null) {
      if (propertyName == 'var_min_val') {
        return 0;
      } else if (propertyName == 'var_max_val') {
        return 10000;
      }
    }
    if (result != null && result == '') {
      result = null;
    }
    return result;
  }

  getRootProduct() {
    
   
    if (!this.getConfig().herculepro.multiProduct && this.globalData && this.globalData.root
      && this.globalData.root.product && this.globalData.root.product.length > 0) {
      return this.globalData.root.product[0];
    }
    if (this.getConfig().herculepro.multiProduct && this.multiGlobalData[this.currentIndexProduct] && this.multiGlobalData[this.currentIndexProduct].root
      && this.multiGlobalData[this.currentIndexProduct].root.product && this.multiGlobalData[this.currentIndexProduct].root.product.length > 0) {
      return this.multiGlobalData[this.currentIndexProduct].root.product[0];
    }
    return null;
 
  }

  getRootProductId() {
    var o = this.getRootProduct();
    if (o) {
      return o.id;
    }
    return null;
  }


  getRootProductAmounts() {
    if (this.getRootProduct() != null && this.getRootProduct().amount) {
      return this.getRootProduct().amount;
    }
    return null;
  }

  getTotalAmount() {
    if (this.globalData != null && this.globalData.root != null 
          && this.globalData.root.prices) {
      return this.globalData.root.prices.lig_ttc;
    }
    return 0;
  }

  getVariables(groupId, questionId, ansId) {

    var answer = this.getAnswer(groupId, questionId);

    if (answer != null && answer.variables && answer.variables.length > 0
      && (ansId == null || ansId == answer.id)) {
      return answer.variables;
    }
    return null;
  }

  getFirstVariable(groupId, questionId) {
    var variables = this.getVariables(groupId, questionId, null);
    if (variables.length > 0) {
      return variables[0];
    }
    return null;
  }

  getVariable(groupId, questionId, varId) {
    var variables = this.getVariables(groupId, questionId, null);
    if (variables != null && variables.length > 0) {

      varId = varId.replace(/___/gi, '.');

      var variable = null;
      for (var i = 0; i < variables.length; i++) {
        var v = variables[i];
        if (v.var_id == varId) {
          variable = v;
          break;
        }
      }
      return variable;
    }
    return null;
  }

  getVariableProperty(groupId, questionId, varId, propName) {
    var variable = null;

    if (varId == null || varId == '') {
      variable = this.getFirstVariable(groupId, questionId);
    } else {
      variable = this.getVariable(groupId, questionId, varId);
    }
    if (variable != null && variable[propName] && variable[propName] != null) {
      return variable[propName];
    }
    return null;
  }

  getVariableMax(groupId, questionId, varId) {
    var v = this.getVariableProperty(groupId, questionId, varId, 'var_max_val');
    return v;
  }

  getVariableMin(groupId, questionId, varId) {
    var v = this.getVariableProperty(groupId, questionId, varId, 'var_min_val');
    return v;
  }

  getVariableHasMax(groupId, questionId, varId) {
    var val = this.getVariableProperty(groupId, questionId, varId, 'var_max_val');
    if (val != null) {
      return true;
    }
    return false;
  }

  getAnswerHasVariables(groupId, questionId, ansId) {

    var answer = this.getAnswer(groupId, questionId);
    if (answer != null && answer.variables && answer.variables.length > 0
      && (ansId == null || answer.id == ansId)) {
      return true;
    }
    return false;
  }

  getAnswers(groupId, questionId) {
    if (this.getGroupById(groupId) != null) {
      var questions = this.getGroupById(groupId).questions;
      if (questions != null && questions[questionId]) {
        var question = questions[questionId];
        if (question != null && question.answers && question.answers.length > 0) {
          return question.answers;
        }
      }
    }
    return null;
  }

  getAnswer(groupId, questionId) {

    var questions = this.getQuestions(groupId);
    if (questions != null && questions.length > 0) {
      var question = null;
      for (var i = 0; i < questions.length; i++) {
        var q = questions[i];
        if (q.id == questionId) {
          question = q;
          break;
        }
      }
      if (question != null && question.answers && question.answers.length > 0) {
        return question.answers[0];
      }
    }
    return null;
  }

  getAnswerProperty(groupId, questionId, propName) {
    var answer = this.getAnswer(groupId, questionId);
    console.log(answer)
    if (answer != null) {
      return answer[propName];
    }
    return null;
  }

  getQuestionICode(groupId, questionId) {
    var question = this.getQuestion(groupId, questionId);
    if (question != null && question.kwsInterpreted != null
      && question.kwsInterpreted != '') {
      var idCodeKw = this.getFirstKeywordStartingWith(question, 'CART_ID.CODE.');
      if (idCodeKw != null) {
        idCodeKw = idCodeKw.replace('CART_ID.CODE.', '');
      }
      return idCodeKw;
    }
    return null;
  }

  getQuestionHasAnswers(groupId, questionId) {
    var answers = this.getAnswers(groupId, questionId);
    if (answers != null && answers.length > 0) {
      return true;
    }
    return false;
  }


  getQuestions(groupId) {

    var questions = null;
    if (groupId == null) {
      questions = [];
      var groups = this.getAllGroups();
      for (var k in groups) {
        var g = groups[k];
        if (g.questions != null) {
          questions.push(...g.questions);
        }
      }

    } else {
      var o = this.getGroupById(groupId);
      if (o != null) {
        questions = o.questions;
      }
    }

    if (questions != null && questions.length > 0) {
      return questions;
    }

    return null;
  }

  getQuestion(groupId, questionId) {
    var questions = this.getQuestions(groupId);
    if (questions != null && questions.length > 0) {

      for (var i = 0; i < questions.length; i++) {
        if (questions[i].id == questionId) {
          return questions[i];
        }
      }
    }
    return null;
  }

  getQuestionProperty(groupId, questionId, propName) {
    var question = this.getQuestion(groupId, questionId);
    if (question != null) {
      return question[propName];
    }
    return null;
  }


  getGlobaldata() {
    return this.globalData;
  }



  setCatId(id: any) {
    this.catId = id;
  }

  getCatId() {
    return (this.showMultiProduct) ? this.startMultiProduct[this.currentIndexProduct].catId : this.catId;
  }
  setDataFamille(fam: any) {
    this.familles = fam;
  }
  getDataFamilles() {
    return this.familles;
  }
  public setCurrentPage(id: number) {
    this.currentPage = id;
  }
  public getCurrentPage() {
    return this.currentPage;
  }

  setListProducts(data: any) {
    this.listProducts[this.currentIndexProduct] = data;
  }
  getListProducts() {
    return this.listProducts[this.currentIndexProduct];
  }
  setDataSousFamilles(fam: any) {
    this.sousFamille = fam;
  }
  getDataSousFamilles() {
    return this.sousFamille;
  }

  setDimension(data: any) {
    this.dimesions = data
  }
  getDimension(data: any) {
    return this.dimesions;
  }


  public generatePdf(data) {

    const body = new HttpParams({ fromObject: data });
    const headers2 = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });
    let options = {
      headers: this.headers
    };
    return this.http.post<any>(this.url_api + `/rest/configuration/generate_pdf` + `?token=` + this.token + "&configurationToken=" + this.currentUserValue.configurationToken,
      "valuesData=" + data, options);
  }

  public sendMail(data) {
    const body = new HttpParams({ fromObject: data });
    const headers2 = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Accept': 'application/json'
    });
    let options = {
      headers: this.headers
    };

    return this.http.post<any>(this.url_api + `/rest/configuration/send_mail` + `?token=` + this.token + "&configurationToken=" + this.currentUserValue.configurationToken, "valuesData="
      + data, options);
  }


  validateProject() {
    let data = {
      "productid": this.productGuid,
      "projectid": this.projectGuid
    }
    // Domaine/rest/configuration/validate/PROJECTGUID/PRODUCTGUID?TOKEN
    return this.http.post<any>(this.url_api + `/rest/configuration/validate/` + this.projectGuid + `/` + this.productGuid + `?token=` + this.token, data)

  }

  getcurrentQuestion() {
    return this.curentQuestion[this.currentIndexProduct];
  }
  setcurrentQuestion(data) {
    this.curentQuestion[this.currentIndexProduct] = data;
  }

  public setbase64String(base64String: string) {
    this.base64String = base64String;
  }

  public getbase64String() {
    return this.base64String;
  }
  public getUrlapi() {
    return this.url_api;
  }


  public getProjectGUID() {
    return this.projectGuid;
  }

  public setRoute_path(path) {

    this.route_path = path;

  }
  public getRoute_path() {

    return this.route_path;

  }

  public getView() {
    return this.vue;
  }

  public setView(val) {
    this.vue = val;
  }

  public setHeaderIn(bool) {

    this.isHeaderIn = bool;
  }
  public getHeaderIn() {

    return this.isHeaderIn;
  }

  getEtape_final() {
    return this.etape_finale;
  }
  setEtape_final(in_step: boolean) {
    this.etape_finale = in_step;
  }

  public getGallery() {
    return this.config.plugin_photos;
  }


  public setIsUploadExt(bool) {

    this.isUploadExt = bool;
  }

  public setIsUploadInt(bool) {

    this.isUploadInt = bool;
  }

  public getImageName(view: any) {

    switch (view) {
      case '1':
        return this.namePhoto_int;

      default:
        return this.namePhoto_ext;

    }


  }

  public setImageName(name) {

    switch (this.vue) {
      case "0":
        this.namePhoto_ext = name;
        break;
      case "1":
        this.namePhoto_int = name;

    }

  }


  public setTypeVisuel(v) {

    switch (this.vue) {
      case '0':
        this.type_visual = v;
        break;
      case '1':
        this.type_visual_int = v;
        break;

    }

  }
  public getTypeVisuel(vue) {
    switch (vue) {
      case '0':
        return this.type_visual;
      case '1':
        return this.type_visual_int;
    }
  }

  public getDataMap() {

    return this.dataMap;
  }

  public setVisual_type(params) {
    this.visual_type = params;
  }
  public getVisual_type() {
    return this.visual_type;
  }

  setTransformCss(data) {
    this.transformCss = data;
  }
  getTransformCss() {
    return this.transformCss;
  }

  getUrl_ambiance() {
    return this.url_ambiance;
  }

  public getProduct() {
    return this.product;
  }

  public setPreviousPage(id) {
    this.previousPage = id;
  }
  public getPreviousPage() {
    return this.previousPage;
  }


  public getCssTargetInt() {
    return this.targetIntCss;
  }

  setFramesExt(data) {
    this.framesExt = data;
  }

  setFramesInt(data) {
    this.framesInt = data;
  }

  getFramesExt() {
    return this.framesExt;
  }

  getFramesInt() {
    return this.framesInt;
  }

  public setInReverse(bool) {
    switch (this.vue) {
      case '1':
        this.inReverseInt = bool;
        break;
      default:
        this.inReverseExt = bool;
    }
  }

  public getInReverse(vue) {
    switch (vue) {
      case '1':
        return this.inReverseInt
      default:
        return this.inReverseExt;


    }
  }

  public getStatut_user() {
    return this.user_is_pro;
  }

  public setStatut_user(is_pro) {
    this.user_is_pro = is_pro;
  }



  public getIsUploadExt(view) {
    if (view === '1') {
      return this.isUploadInt;
    }
    return this.isUploadExt;
  }

  public getIsUploadInt() {

    return this.isUploadInt;
  }


  setImageCanvasExt(coord) {
    this.imageCanvasExt = coord;
  }
  getImageCanvasExt() {
    return this.imageCanvasExt;
  }

  setImageCanvasInt(coord) {
    this.imageCanvasInt = coord;
  }
  getImageCanvasInt() {
    return this.imageCanvasInt;
  }

  public setCssTarget(params) {
    this.targetCss = params;
  }
  public getCssTarget() {
    return this.targetCss;
  }

  public setCssTargetInt(params) {
    this.targetIntCss = params;
  }

  getImage() {
    return null; //url_api + this.data_profile + "/porte/" + this.vue + this.infos.simuleoCode + "/image.png?uuid=" + this.uuid;
  }

  getIntImage() {
    return null; //url_api + this.data_profile + "/porte/" + this.vue + this.infosInt.simuleoCode + "/image.png?uuid=" + this.uuid;
  }

  public setLastdata(params) {

    return this.lastData = params;
  }

  public getGalleryDialog() {
    return this.config.plugin_photos_dialog;
  }



  getCatalog_filters_def() {
    return this.catalog_filters_def;
  }

  getThumbnails() {
    return this.thumbnails;
  }

  public getLastdata() {

    return this.lastData;
  }

  public getLimit() {
    return this.limit_;

  }

  public getHref_iframe() {
    return this.href_iframe;
  }

  public setWarpable(bool) {
    this.warpable = bool;

  }
  public getWarpable() {

    return this.warpable;
  }

  public setDataMap(params) {

    return this.dataMap = params;
  }

  setPanneaux(val) {
    this.panneaux.push(val);
  }

  getPanneaux() {
    return this.panneaux
  }

  setModeles(val) {
    this.panneaux.push(val);
  }

  getModeles() {
    return this.modeles
  }
  clearModeles() {
    this.modeles = [];
  }

  assignQuestionToAnswers(questionId: any, answers: any) {

    if (answers != null && answers.root && answers.root.data
      && answers.root.data.length > 0) {
      var question = this.questionsById[questionId];
      for (var i = 0; i < answers.root.data.length; i++) {
        answers.root.data[i].question_id = questionId;
        if (question != null) {
          answers.root.data[i].grpId = question.grpId;
        }
      }
    }
  }


  /***
   * Get list object
   */

  getElementObjects(element: any) {
    var groups = this.multiGlobalData[this.currentIndexProduct].root.product[0].groups;
    var grp = null;
    let default_element
    for (var name in groups) {
      grp = groups[name];
      grp.kwsInterpreted = this.doInterpretKeywords(grp.keywords);
      grp.className = this.formatKeywordAsClassName(this.getFirstKeyword(grp));

      if (grp.questions) {
        let i = grp.questions.length;
        let question = null;
        while (i--) {
          question = grp.questions[i];
          question.kwsInterpreted = this.doInterpretKeywords(question.keywords);
          if (this.hasKeywords(question, element)) {
            default_element = grp.questions[i];
          }

        }
      }
    }
    return default_element;
  }

  getCurrentType_gamme(name) {
    switch (name) {
      case 'MODELE':
        return this.currentElement_type[this.currentIndexProduct];
      case 'VITRAGE':
        return this.currentVitrage_type[this.currentIndexProduct];
      case 'GAMME':
        return this.currentGamme[this.currentIndexProduct];
      case 'OUVERTURE':
          return this.currentType_ouverture[this.currentIndexProduct];
      case 'MATIERE':
            return this.currentMatiere[this.currentIndexProduct];      
                 
      case 'TYPE_DE_GAMME':
        return this.currentType_gamme[this.currentIndexProduct];

      case 'MODELE_PANNEAU':
        return this.currentModele[this.currentIndexProduct];
      case 'COULEUR':
        return this.currentColor[this.currentIndexProduct];
    }
  }

  getQuestionObject(name) {
    switch (name) {
      case 'FORME':
        return this.currentForme[this.currentIndexProduct];

      case 'MODELE':
        return this.currentElement_type[this.currentIndexProduct];
      case 'VITRAGE':
        return this.currentVitrage_type[this.currentIndexProduct];
      case 'GAMME':       
        return this.currentGamme[this.currentIndexProduct];
      case 'OUVERTURE':
          return this.currentType_ouverture[this.currentIndexProduct];
      case 'MATIERE':
          return this.currentMatiere[this.currentIndexProduct];      
      case 'TYPE_DE_GAMME':
        return this.currentType_gamme[this.currentIndexProduct];

      case 'MODELE_PANNEAU':
        return this.currentModele[this.currentIndexProduct];
      case 'COULEUR':
        return this.currentColor[this.currentIndexProduct];
    }
  }
  resetProduct(prodId) {
    var me = this;
    this.init().then(function (result) {

      if ((me.productGuid == null || me.productGuid == '')
        && (me.projectGuid == null || me.projectGuid == '')) {
          me.fetchOneProduct(me.getCatId(), prodId, true).subscribe(data => {
          me.setGlobaldata(data);
          me.initDefaultCoulor();

        });
      }

    });
  }

  setAppLoader(loader: boolean) {
    this.app_loader = loader;
  }
  getAppLoader() {
    return this.app_loader
  }

  setQuestionKeywords(keywords) {
    this.questionKewords = keywords;
  }

  getQuestionKeywords() {
    let keyword = this.questionKewords.replace(/,/g, ' ');
    return keyword.toLocaleLowerCase();
  }

  getArraywords(keywords) {
    let keywords_array = keywords.split(',');
    return keywords_array;
  }
  findKeywordIndex(obj: any, keyword: string) {
    const isChecked = (element) => element === keyword;

    console.log(obj.findIndex(isChecked));
    return (obj.findIndex(isChecked))

  }

  getOptionSelected(): any {
    return this.optionSelected;
  }
  clearOptionSelected() {
    this.optionSelected = {};
  }
  getUrl_api() {
    return this.url_api;
  }

  getIsMobile() {
    return this.isMobile;
  }

  getIsTablet() {
    return this.isTablet;
  }

  getIsDesktop() {
    return this.isDesktop;
  }

  getIsPortrait() {
    return this.isPortrait;
  }

  getIsLandscape() {
    return this.isLandscape;
  }

  getIsDkptMinWidth() {
    return this.isDkptMinWidth;
  }



  initBrowserSpecifics(windowInnerHeight: any, windowInnerWidth: any) {
   
    this.isMobile = false;
    this.isTablet = false;
    this.isDesktop = false;
    this.isLandscape = false;
    this.isPortrait = false;
    this.isDkptMinWidth = false;

    if (windowInnerHeight >= windowInnerWidth) {
      this.isPortrait = true;
    } else {
      this.isLandscape = true;
    }

    if (windowInnerWidth <= this.breakPointWidthPhone
      || windowInnerHeight < this.breakPointHeightPhone) {
      this.isMobile = true;
    } else if (windowInnerWidth <= this.breakPointWidthTablet
      || windowInnerHeight < this.breakPointHeightTablet) {
      this.isTablet = true;
    } else {

      //si détecter comme desktop, on procède a d'autres verif, via le user agent par exemple.

      this.isDesktop = true;
      if (windowInnerWidth <= this.breakPointWidthDkptMini) {
        this.isDkptMinWidth = true;
      }
    }
    this.emitDataChange();
  }

  getMenuAnswerState() {
    return this.menuAnswerState;
  }
  setMenuAnswerState(menuAnswerState) {
    this.menuAnswerState = menuAnswerState;
  }

  getMultiMenuAnswerState() {
    return this.multiMenuAnswerState;
  }
  setMultiMenuAnswerState(menuAnswerState) {
    this.multiMenuAnswerState = menuAnswerState;
  }

  setFormeId(id) {
    this.currentFormeId = id
  }
  getFormeId() {
    return this.currentFormeId;
  }
  /**
     * 
     * @param cat >Multi
     * @param index_ 
     */

  loadMultiConfig(index_,currentProduct){
   console.log(this.productSelected+"  >>> " +this.dataobj.multiProduct[this.productSelected]["catalogs"]+ ">>>>>>>>> "+index_)
    this.showMultiProduct = this.isPageCatalogue ? false : true;
    this.loadCatalog = this.isPageCatalogue ? false:true;
    this.startMultiProduct[currentProduct] = this.dataobj.multiProduct[this.productSelected]["catalogs"][index_].start_product;
    this.multiProductCatId = encodeURIComponent(this.dataobj.multiProduct[this.productSelected]["catalogs"][index_].api_cat_id); 
    if (this.multiProductCatId != null && this.multiProductCatId != ''
    && (this.startMultiProduct[currentProduct] != null && this.startMultiProduct[currentProduct].id != null)) {
     this.startMultiProduct[currentProduct].catId = this.multiProductCatId;
     this.questionsById[currentProduct] = {};
     this.questionsByIdCode[currentProduct] = {};
     //this.setProduct(this.startProduct);
  
  }
}
/**
 * Init product via la création un nouveau catalog
 *  
 */
public doInitDirectMultiProduct(index_,currentProduct) {

  return new Promise<void>((resolve, reject) => {

  this.currentIndexProduct = currentProduct;
  this.loadCatalog = (this.isPageCatalogue)? false: true;
  var me = this;
    if ((me.productGuid == null || me.productGuid == '')
      && (me.projectGuid == null || me.projectGuid == '')) {
        me.fetchOneProduct(me.multiProductCatId, me.startMultiProduct[currentProduct].id,false).subscribe(data => {
         me.setGlobaldata(data);
         me.globalDataProduct= data;
        
        if (me.startDirectProductConfig[me.currentIndexProduct]  != null) {
          var items = [];
          for (var k in me.startDirectProductConfig[me.currentIndexProduct] ) {
            items.push(me.startDirectProductConfig[me.currentIndexProduct][k]);
          }
          me.selectItems(items, me.onDirectSelectItemsDone, me);
        } else {
          me.initDefaultCoulor();
          me.initSelecteurPorte();
        }
        me.emitDataChange();
       this.app_loader = true;
        me.loadProduct(index_,currentProduct);
        //this.loadProduct(index_,currentIndex)
       // return this.multiGlobalData
        me. emitDataChange();
      });
    }

  setTimeout(() => {
    ///console.log('AppInitService Finished' +  this.globalDataProduct.root.product[0].groups["GPIV37.M1XAAW.L8KQLV.1QG9VOO_0_113171"].questions[0].code);
   
      resolve();
  }, 1000);

});
}
/**
 * Création token pour chaque catalogue
 * 
 */
initToken(): Promise<any> {

  return new Promise<void>((resolve, reject) => {
    let data = {
      "user": this.api_username,
      "pass": this.api_pwd
    };
    this.app_loader = true;
    let url = "pass=" + this.api_pwd;
     this.http.post<any>(this.url_api + "/rest/users/" + this.api_username + "/authenticate?" + url, data).subscribe(res => {
      var url = this.url_api + "/rest/configurations/create?token=" + res.root.token;
      this.http.post<any>(url, {}).subscribe(
        resData => {
          this.token = res.root.token;
          let auth = {
            "token": res.root.token,
            "configurationToken": resData.root.configurationToken,
            "elapsedTime": resData.root.elapsedTime
          }
          this.multiProductTokens.push(auth);
         });
      setTimeout(() => {
        console.log('AppInitService Finished');

        resolve();
      }, 1000);
    });
  });
}
/**
 * 
 * @returns Liste des catalogues(produits)
 */
getMultiGlobaldata(){
    return this.multiGlobalData;
}
 getcurrentGlobaldata() {
    return this.multiGlobalData[this.currentIndexProduct];
  }

/**
   * 
   * @returns 
   */
loadProduct(index_,currentIndex) {

  this.showMultiProduct = true;
  this.currentIndexProduct = currentIndex;
  this.catalog_index = index_
  this.configLoaded = true;
  this.multiProductCatId = encodeURIComponent(this.dataobj.multiProduct[this.productSelected]["catalogs"][index_].api_cat_id);
  this.startMultiProduct.push(this.dataobj.multiProduct[this.productSelected]["catalogs"][index_].start_product);
  
     if (this.multiProductCatId != null && this.multiProductCatId != ''
        && (this.startMultiProduct[this.currentIndexProduct] != null && this.startMultiProduct[this.currentIndexProduct].id != null)) {
        this.startMultiProduct[this.currentIndexProduct].catId = this.multiProductCatId;
        this.setMultiProduct(this.startMultiProduct[this.currentIndexProduct]);
        this.app_loader =  false;
        }
   
} 

confirmeProduct() {

  console.log(this.getCurrentAnswerMutliProd("CART_ID.CODE.MODELE").answers[0].id + " loadProduct");
      
  let clone = {"parentIndex":this.currentIndexProduct,"idModele":this.getCurrentAnswerMutliProd("CART_ID.CODE.MODELE").answers[0].id,"isClone":false}
  this.cloneControle.push(clone);
}
/**
 * Colner un produit pour Fenetres,Volets et clotures
 */
cloneObject(){

 console.log(this.getCurrentAnswerMutliProd("CART_ID.CODE.MODELE").answers[0].id + " currentAnswerMutliProd")
  console.log(this.multiGlobalData[this.currentIndexProduct].root.product[0].id + " cloneObject")
  this.multiGlobalData.push(this.multiGlobalData[this.currentIndexProduct]);
  this.multiProductTokens.push(this.multiProductTokens[this.currentIndexProduct]);
  this.startMultiProduct.push(this.startMultiProduct[this.currentIndexProduct]);
  this.questionsById[this.currentIndexProduct+1]={}
 this.questionsByIdCode[this.currentIndexProduct+1]={};

  let clone = {"parentIndex":this.currentIndexProduct,"idModele":this.getCurrentAnswerMutliProd("CART_ID.CODE.MODELE").answers[0].id,"isClone":true}
  this.cloneControle.push(clone);
  this.emitDataChange();
  } 

  removeProducts(index_)
  {
    
    this.multiGlobalData.splice(index_,1);
    this.startMultiProduct.splice(index_,1);
    this.cloneControle.splice(index_,1);
    this.multiProductTokens.splice(index_,1);
    //this.multiProductTokens.splice(index_,1);
    console.log(this.currentIndexProduct + " removeProducts")
  
  }
  public getCloneControle()
  {
    return this.cloneControle;
  }
  public setMultiProduct(product: any) {
    this.currentMultiProduct.push(product)
  }
  public getMultiProduct() {
    return  this.currentMultiProduct;
  }

  setShowMultiproduct(show)
  {
    this.showMultiProduct = show;
  }
  
  getShowMultiproduct()
  {
    return this.showMultiProduct;
  }
  isMultiProducts()
  {
  return this.getConfig().herculepro.multiProduct;
  }
  setCurrentProductIndex(index_)
  {
 
    this.currentIndexProduct = index_;  
    this.arrayProduct_index = index_;
    this.currentModeleAnswerId = (this.cloneControle[index_]) ? this.cloneControle[index_].idModele : null;
    
    
  } 
  getCurrentProductIndex()
  {
     return this.currentIndexProduct 
    
  } 
  setCurrentArrayProductIndex(index_)
  {
   this.arrayProduct_index = index_;    
    
  }  
  getCurrentArrayProductIndex()
  {
     return this.arrayProduct_index 
    
  }  

  getMultiProductGroups(): any {
    return this.getAllGroups();
  }



getproductsFrames(){
 return this.productsFrames;
}
setproductsFrames(data){
 this.productsFrames = [];
 this.productsFrames = data;
}
gettransformCss_w(){

  return this.transformCss_w;
}
settransformCss_w(data){
  this.transformCss_w.push(data);
}
updateObjecttransformCss_w(data)
{
this.transformCss_w[this.arrayProduct_index]= data;
}
removeObjectTransformCss_w(i)
{
  this.transformCss_w.splice(i,1);
}
setListCatalog(catalog)
{
  this.list_catalog.push(catalog);
}
updateListCatalog(i,catalog)
{
  this.list_catalog = [];
  console.log(this.list_catalog)
  this.list_catalog[i] =catalog;
}
getListCalogLoaded()
{
  return this.list_catalog;
}
removeCatalogLoaded(i)
{
  this.list_catalog.splice(i,1);
}
/**
 * 
 * @returns Liste des catalogues(produits slectionné) data.json
 */
getListCataglog()
{
  return this.dataobj.multiProduct[this.productSelected]["catalogs"];
}

/**
 * 
 * @returns Liste des catalogues(produits) data.json
 */
getAllCataglog()
{
  return this.dataobj.multiProduct;
}
/**
 * 
 * @param id set get Id  current id tableau list Catalog fichier config
 */
setListCatalogId(id)
{
this.listCatalogId = id
}
getListCatalogId()
{
return this.listCatalogId 
}
setCatalogSlug(slug)
{
this.catalogSlug = slug
}
getCatalogSlug()
{
return this.catalogSlug; 
}
/**
 * 
 * @param index_ du catalog dans la liste multiProduct de fichier dataJson
 */

setCatalogIndex(index_)
{
  this.catalog_index = index_;
}
getCatalogIndex()
{
  return this.catalog_index;
}
 
getAmbiancesView(id: any) {


  var ambiance = []

  for (var i = 0; i < this.config.plugin_photos_dialog.length; i++) {


    if (this.config.plugin_photos_dialog[i].vue === id) {
      ambiance.push(this.config.plugin_photos_dialog[i]);
    }


  }

  return ambiance;
}
  getStatutMatButton() {
    return this.matButtonDisabled
  }
  setStatutMatButton(disabled_) {
    this.matButtonDisabled = disabled_;
  }

 /**
  * 
  Mettre a jour le produit via le menu Multi Produit 
  */ 
 setBooleanParam(name,bool)
 {
  switch(name)
  {
    case "loadCatalo":
      this.loadCatalog = bool;
      break;
    case "isPagecatalog":
        this.isPageCatalogue = bool;
        break; 
    case "standard-menu-answer":
        this.standardMenu_answer = bool; 
        break;   

  }
  
 }
 getBooleanParam(name)
 {  

  switch(name)
  {
    case "loadCatalo":
      return this.loadCatalog ;
    case "isPagecatalog":
       return  this.isPageCatalogue ;
    case "standard-menu-answer":
        return  this.standardMenu_answer ;
  }
  
 }
/**
 * questions 
 */
setgroupId(grpId)
{
this.currentGroupId = grpId
}
getgroupId()
{
return this.currentGroupId; 
}
setQuestionsGrpId(data) {
  this.currentQuestionsGrpId = data;
}
getQuestionsGrpId() {
  return this.currentQuestionsGrpId;
}

/***
 * Get list question by id group
 */

  getQustionByKeyword(keyword: any,groups:any) {
    
    var grp = null;
    let default_element
      if (groups) {
        let i = groups.length;
        let question = null;
        while (i--) {
          question = groups[i];
          question.kwsInterpreted = this.doInterpretKeywords(question.keywords);
          if (this.hasKeywords(question, keyword)) {
            default_element = groups[i];
          }

        }
      }
   
    return default_element;
  }

setshowMenuWindows(show)
{
this.showMenuWindows = show
}  
getshowMenuWindows()
{
  return this.showMenuWindows
}
setProduct_answers(data:any)
{
this.product_answers  = data
}  
getProduct_answers()
{
  return this.product_answers 
}

/**
 * 
 * Hidden question by keyword data json catalog fenetre 
 */
searchQstNoVisible(searchKeyword) {
 
 return this.getListCataglog()[this.catalog_index].question_no_visible.indexOf(searchKeyword);
}
setCurrentKeyword(keyword:string)
{
 
   this.currentKeyword = keyword.toLowerCase();
}
getCurrentKeyword()
{
  return this.currentKeyword;
}
setAnswerProgress(bool_)
{
  this.answerProgress = bool_;
}
getAnswerProgress()
{
  return this.answerProgress;
}
setCurrentAnswerWindowId(id)
{
  this.currentModeleAnswerId = id;
}
getCurrentAnswerWindowId()
{
  return this.currentModeleAnswerId;
}

getCurrentAnswerMutliProd(keyword)
{

  var groups = this.multiGlobalData[this.currentIndexProduct].root.product[0].groups;
  var grp = null;
  for (var name in groups) {
    grp = groups[name];
    grp.kwsInterpreted = this.doInterpretKeywords(grp.keywords);
    grp.className = this.formatKeywordAsClassName(this.getFirstKeyword(grp));
    if (grp.questions) {
      let i = grp.questions.length;
      let question = null;
      while (i--) {
        question = grp.questions[i];
        question.grpId = name;
        question.kwsInterpreted = this.doInterpretKeywords(question.keywords);
        if (this.hasKeywords(question, keyword)) {

          return question;
         }

      }
    }
  }

}
/**
 * 
 * @param bool_ Mobile affichage menu question après click revenir au simulateur(message popup qts obligatoire)
 */
setModalInfoOpened(bool_)
{
  this.modalInfoOpened = bool_;

}
getModalInfoOpened()
{
  return this.modalInfoOpened;
}
setFilterKeyword(keyword)
{
  this.filterKeyword = keyword;
}
getFilterKeyword()
{
  return this.filterKeyword;
}
setSubTitleSelected (selected)
{
  this.subTitleSelected = selected;
}
getSubTitleSelected ()
{
  return this.subTitleSelected;
}
setCurrentProduct(product)
{
  this.productSelected = product;
}
getCurrentProduct()
{
  return this.productSelected;
}
getSimulateurActive()
{
  return  this.simulateurActive;
} 
setSimulateurActive(isActive)
{
  this.simulateurActive = isActive;
} 
}
